import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import EditGroupView from './edit-group/EditGroupView';
import ListGroupsView from './list-groups/ListGroupsView';
import LocaleContext from '../../constants/localization';


const ManageGroupsView = ({ id }) => {
  const LS = useContext(LocaleContext);

  const [edit, setEdit] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState({});

  useEffect(() => {
    if (id) {
      setEdit(true);
      setSelectedGroup({ id: id });
    }
  }, []);

  const handleCancel = () => setEdit(false);

  return (
    <div className="manage-groups">
      <h1>{LS.manageGroups.groupManagement}</h1>

      {!edit ? (
        <ListGroupsView setSelectedGroup={setSelectedGroup} setEdit={setEdit} />
      ) : (
        <EditGroupView handleCancel={handleCancel} group={selectedGroup} />
      )}
    </div>
  );
};

export default connect()(ManageGroupsView);
